export const MuiOutlinedInput = {
  styleOverrides: {
    notchedOutline: {
      // Hide the legend because the label is statically positioned via MuiInputLabel,
      // so the legend is not needed for the floating label effect.
      '& legend': { display: 'none' },
      top: 0,
    },
  },
}
